import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-add-destination-partial-success-modal',
  templateUrl: './add-destination-partial-success-modal.component.html',
  imports: [CommonModule, ButtonComponent, ReactiveFormsModule, I18NextPipe, ModalComponent, CheckboxComponent, ModalFooterDirective]
})
export class AddDestinationPartialSuccessModalComponent {
  public confirmed = new FormControl();
  public extensions: string[];
  public hasObjectLockWarning: boolean;
}
